module.exports = __webpack_public_path__ + "img/Tripod-Mount.6ab85c9d.png";